/* tslint:disable */
/* eslint-disable */
/* @relayHash a364f3dfe18b1a4cae153da527721e90 */

import { ConcreteRequest } from "relay-runtime";
export type AcknowledgeModMessageInput = {
    clientMutationId: string;
};
export type AcknowledgeModMessageMutationVariables = {
    input: AcknowledgeModMessageInput;
};
export type AcknowledgeModMessageMutationResponse = {
    readonly acknowledgeModMessage: {
        readonly user: {
            readonly id: string;
            readonly status: {
                readonly modMessage: {
                    readonly active: boolean;
                };
            };
        };
        readonly clientMutationId: string;
    } | null;
};
export type AcknowledgeModMessageMutation = {
    readonly response: AcknowledgeModMessageMutationResponse;
    readonly variables: AcknowledgeModMessageMutationVariables;
};



/*
mutation AcknowledgeModMessageMutation(
  $input: AcknowledgeModMessageInput!
) {
  acknowledgeModMessage(input: $input) {
    user {
      id
      status {
        modMessage {
          active
        }
      }
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "AcknowledgeModMessagePayload",
            "kind": "LinkedField",
            "name": "acknowledgeModMessage",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ModMessageStatus",
                                    "kind": "LinkedField",
                                    "name": "modMessage",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "active",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AcknowledgeModMessageMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AcknowledgeModMessageMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "a364f3dfe18b1a4cae153da527721e90",
            "metadata": {},
            "name": "AcknowledgeModMessageMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '19f7e850de960dbb30716f4e8ef2b953';
export default node;
